import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/analytics";
import store from "../store/configureStore";
import { getFromController } from "../actions/apiActions";

const firebaseConfig = {
    apiKey: "AIzaSyARvAOJptCcsCmgars6XsrGIxWykYM-D6U",
    authDomain: "kingpricemobile-c77db.firebaseapp.com",
    databaseURL: "https://kingpricemobile-c77db.firebaseio.com",
    projectId: "kingpricemobile-c77db",
    storageBucket: "kingpricemobile-c77db.appspot.com",
    messagingSenderId: "728762391544",
    appId: "1:728762391544:web:25087f95d17561ccd7940d",
    measurementId: "G-PEGP9HKVS7"
};

const firebaseNamConfig = {
    apiKey: "AIzaSyARvAOJptCcsCmgars6XsrGIxWykYM-D6U",
    authDomain: "kingpricemobile-c77db.firebaseapp.com",
    databaseURL: "https://kingpricemobile-c77db.firebaseio.com",
    projectId: "kingpricemobile-c77db",
    storageBucket: "kingpricemobile-c77db.appspot.com",
    messagingSenderId: "728762391544",
    appId: "1:728762391544:web:958deebf7a567f09d7940d",
    measurementId: "G-9MQBWZGY5M"
};

const dispatch = store.dispatch;
let isSA = false;
    getFromController(dispatch, 'CountryId', null).then(async (response) => {
    if (response === 244) {
        isSA = true
    }
});

if (isSA) {
    firebase.initializeApp(firebaseConfig);
}
else {
    firebase.initializeApp(firebaseNamConfig);
}
const analytics = firebase.analytics();
analytics.setAnalyticsCollectionEnabled(true);

export default firebase;

export const logEvent = (event, params) => {
    analytics.logEvent(event, { params });
};

export const setCurrentScreen = (screen) => {
    analytics.setCurrentScreen(screen, screen);
};

export const setUserId = (id) => {
    analytics.setUserId(id);
};

export const setUserProperties = (key, value) => {
    analytics.setUserProperties(key, value);
};

